"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import _ from "underscore";
import s from "underscore.string";
function bouncedEmails(props, state) {
  return _.intersection(props.recipients, state.bouncedEmails);
}
function emails(props, state) {
  return s.toSentenceSerial(bouncedEmails(props, state));
}
export default class extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      bouncedEmails: []
    });
    __publicField(this, "ignoreLink", () => {
      return /* @__PURE__ */ jsx("a", { onClick: this.ignoreBounces, children: "Yes, please" });
    });
    __publicField(this, "setBouncedEmails", (bounces) => {
      const emails2 = _.map(bounces, "email");
      this.setState({ bouncedEmails: emails2 });
    });
    __publicField(this, "fetchBounces", (recipients) => {
      if (_.isEmpty(_.compact(recipients))) {
        this.setBouncedEmails([]);
        return;
      }
      jQuery.get({
        url: "/api/bouncing_email_addresses",
        data: { emails: recipients },
        success: this.setBouncedEmails
      });
    });
    __publicField(this, "ignoreBounces", () => {
      jQuery.ajax({
        url: "/api/bouncing_email_addresses",
        method: "DELETE",
        data: { emails: bouncedEmails(this.props, this.state) },
        success: this.setBouncedEmails
      });
    });
  }
  componentDidMount() {
    this.fetchBounces(this.props.recipients);
  }
  componentWillReceiveProps(nextProps) {
    if (!_.isEqual(nextProps.recipients, this.props.recipients)) {
      this.fetchBounces(nextProps.recipients);
    }
  }
  render() {
    if (_.isEmpty(bouncedEmails(this.props, this.state))) {
      return null;
    } else {
      return /* @__PURE__ */ jsxs("div", { className: "alert-box--caution accounts-payable-bounces-message", children: [
        "We were previously unable to send to",
        " ",
        /* @__PURE__ */ jsx("strong", { children: emails(this.props, this.state) }),
        "... should we try again? ",
        this.ignoreLink(),
        "."
      ] });
    }
  }
}
